<div class="card-content">
  <!--共用：title 區域-->
  <h1 class="card-title">{{ 'business-login.title' | translate }}</h1>
  <p class="card-subtitle">{{ 'business-login.hint' | translate }}</p>

  <form
    [formGroup]="businessLoginForm"
    (ngSubmit)="onSubmit()"
    class="login-form"
  >
    <!-- <div class="input-block">
      <label class="input-title">{{
        'business-login.company-number' | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          matInput
          formControlName="companyNo"
          [maxLength]="companyNoMaxLength"
          [placeholder]="
            'business-login.company-number-placeholder' | translate
          "
          [ngClass]="{
            'input-error':
              showError && businessLoginForm.get('companyNo')?.invalid,
          }"
        />
        @if (showError && businessLoginForm.get('companyNo')?.invalid) {
          <mat-error class="input-error-msg">{{
            getCompanyNoErrorMessage()
          }}</mat-error>
        }
      </div>
    </div> -->

    @if (controlItem === 1) {
      <div class="input-block">
        <label class="input-title">
            {{ 'business-login.employee-id' | translate }}
        </label>
        <div class="input-group">
          <input
            type="text"
            matInput
            appAlphaNumericOnly
            formControlName="empId"
            [maxlength]="idNumberMaxLength"
            [placeholder]="'business-login.employee-id-placeholder' | translate"
            [ngClass]="{
              'input-error': showError && businessLoginForm.get('empId')?.invalid,
            }"
          />
          @if (showError && businessLoginForm.get('empId')?.invalid) {
            <mat-error class="input-error-msg">{{
              getEmpIdErrorMessage()
            }}</mat-error>
          }
          <!-- <mat-checkbox
            [(ngModel)]="fillIdNumberChecked"
            [ngModelOptions]="{ standalone: true }"
            (change)="onFillIdNumberChange($event.checked)"
            >
          {{ 'business-login.fill-id-number' | translate }}
          </mat-checkbox> -->
        </div>
      </div>
    }

    <div class="input-block">
      <label class="input-title input-text-required">{{
        'business-login.select-identity' | translate
      }}</label>
      <mat-radio-group formControlName="identity">
        <mat-radio-button [value]="API_PARAMS.IDENTITY.EMPLOYEE"
          >{{ 'business-login.identity-employee' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="API_PARAMS.IDENTITY.EMPLOYEE_DEPENDENTS"
          >{{ 'business-login.identity-employee-dependents' | translate }}
        </mat-radio-button>
      </mat-radio-group>
      @if (showError && businessLoginForm.get('identity')?.invalid) {
        <mat-error class="input-error-msg">{{
          'error.identity-error' | translate
        }}</mat-error>
      }
    </div>

    <!--共用：開始預約 btn-->
    <button mat-button type="submit" class="btn-fill-primary btn-size-l">
      {{ 'business-login.start-reserve' | translate }}
    </button>
  </form>
</div>
